import { createSelector } from '@reduxjs/toolkit';

import { initialState } from '.';

export const selectOrgainsationUiSlice = state =>
  state.OrganisationUi || initialState;

export const selectOrganisationUi = createSelector(
  [selectOrgainsationUiSlice],
  state => state,
);

export const selectOrganisationUiDetails = createSelector(
  [selectOrgainsationUiSlice],
  state => state.OrganisationUiDetails,
);

export const selectOrganisationUiError = createSelector(
  [selectOrgainsationUiSlice],
  state => state.error,
);
